import PropTypes from "prop-types";
import React from "react";

const SEO = ({ title, jsonLd, openGraph }) => {
  return (
    <>
      <meta charSet="utf-8" />
      <title>{title} || We are a 360 degree software solution provider.</title>
      <meta name="robots" content="follow" />
      <meta
        name="description"
        content="We are a 360 degree software solution provider."
      />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      {openGraph?.title && (
        <meta property="og:title" content={openGraph.title} />
      )}
      {openGraph?.description && (
        <meta property="og:description" content={openGraph.description} />
      )}
      {openGraph?.url && <meta property="og:url" content={openGraph.url} />}
      {openGraph?.type && <meta property="og:type" content={openGraph.type} />}
      {openGraph?.image && (
        <meta property="og:image" content={openGraph.image} />
      )}
      {Array.isArray(jsonLd) &&
        jsonLd.map((item, idx) => (
          <script
            key={idx}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
          />
        ))}
      {!Array.isArray(jsonLd) && jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
};
SEO.propTypes = {
  title: PropTypes.string,
  jsonLd: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object),
  ]),
  openGraph: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string,
    type: PropTypes.string,
    image: PropTypes.string,
  }),
};

export default SEO;
